var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9868 4.34778L8.65124 5.01222L2.10791 11.5556H1.44347V10.8911L7.9868 4.34778ZM10.5868 0C10.4062 0 10.2185 0.0722222 10.0812 0.209444L8.75958 1.53111L11.4679 4.23944L12.7896 2.91778C13.0712 2.63611 13.0712 2.18111 12.7896 1.89944L11.0996 0.209444C10.9551 0.065 10.7746 0 10.5868 0ZM7.9868 2.30389L-0.000976562 10.2917V13H2.70736L10.6951 5.01222L7.9868 2.30389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEditIcon);
export default __webpack_public_path__ + "static/media/white-edit-icon.c64840ba857ea9814986e803013fb5a1.svg";
export { ForwardRef as ReactComponent };